import { render, staticRenderFns } from "./InvoiceSIIDetail.vue?vue&type=template&id=0d08f9ba&"
import script from "./InvoiceSIIDetail.vue?vue&type=script&lang=js&"
export * from "./InvoiceSIIDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports